import { render, staticRenderFns } from "./editorLibraryItem.vue?vue&type=template&id=a5061026&scoped=true&"
import script from "./editorLibraryItem.vue?vue&type=script&lang=js&"
export * from "./editorLibraryItem.vue?vue&type=script&lang=js&"
import style0 from "./editorLibraryItem.vue?vue&type=style&index=0&id=a5061026&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "a5061026",
  null
  
)

export default component.exports